import { render, staticRenderFns } from "./MdWait.vue?vue&type=template&id=e4ac1cec&"
import script from "./MdWait.vue?vue&type=script&lang=js&"
export * from "./MdWait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports